var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloudIcon = function SvgCloudIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.523980453%",
    y1: "49.9999129%",
    x2: "116.749138%",
    y2: "49.9999129%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E93E3A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED683C",
    offset: "35.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3903F",
    offset: "70.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC70C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.13186294,4.23299743 C6.17329722,4.25427279 6.2108888,4.28535957 6.24254928,4.32450208 L7.69542237,6.12113262 C7.83150391,6.28358949 7.83526309,6.55170015 7.70385959,6.71994061 C7.57237258,6.88828436 7.35551089,6.89293188 7.21942932,6.73037174 C7.21658908,6.72696354 7.21374884,6.72355536 7.2109921,6.71994061 L6.34254289,5.64594882 L6.34254289,10.9764554 C6.34254289,11.2103809 6.18916922,11.4 5.99995823,11.4 C5.81083078,11.4 5.6574571,11.2103809 5.6574571,10.9764554 L5.6574571,5.64584555 L4.78900789,6.71994061 C4.65752088,6.88828436 4.44065916,6.89293188 4.30457762,6.73037174 C4.16849608,6.56791484 4.16473693,6.29980419 4.2961404,6.13156373 L4.30457762,6.12113262 L4.30457762,6.12113262 L5.75745072,4.32450208 C5.78911119,4.28535957 5.82670277,4.25427279 5.86813705,4.23299743 C5.95242576,4.18900086 6.04757425,4.18900086 6.13186294,4.23299743 Z M5.2752565,0.674401039 C7.30881397,0.262130211 9.28588374,1.60473433 9.69118534,3.67325918 C11.0031284,3.83660299 11.991709,4.96566815 12,6.3101348 C12.0089208,7.7864685 10.8396161,8.99077984 9.38823909,9 L9.38823909,9 L7.51096123,9 C7.3035955,9 7.13550566,8.82901919 7.13550566,8.61808777 C7.13550566,8.40715633 7.3035955,8.23617618 7.51096123,8.23617618 L7.51096123,8.23617618 L9.38814754,8.23617618 C10.4249762,8.23617618 11.2654254,7.38127528 11.2654254,6.32671132 C11.2654254,5.27205418 10.4249762,4.41715331 9.38814754,4.41715331 C9.19204272,4.41845709 9.02431909,4.27420422 8.99282513,4.07724176 C8.83260879,2.66805222 7.73975018,1.55640171 6.35438229,1.3934304 C4.70653423,1.19954113 3.21615596,2.40115178 3.02554429,4.07733488 C3.00448727,4.27075852 2.84372161,4.41724645 2.65237752,4.41715331 C1.61554886,4.41100698 0.770155829,5.26087901 0.764021825,6.315443 C0.757887846,7.37000699 1.59339321,8.2299367 2.63022188,8.23617618 L2.63022188,8.23617618 L4.50740819,8.23617618 C4.71477392,8.23617618 4.88286378,8.40715633 4.88286378,8.61808777 C4.88286378,8.82901919 4.71477392,9 4.50740819,9 L4.50740819,9 L2.63022188,9 C1.29438372,9.00093061 0.170397359,7.98249969 0.0175051963,6.63263172 C-0.148570507,5.16589002 0.885694694,3.83995555 2.32755031,3.67093102 C2.62491186,2.15818486 3.78789946,0.975944493 5.2752565,0.674401039 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Register",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0.4-Signup-/-2",
    transform: "translate(-1226.000000, -401.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Log-In-Form-Copy",
    transform: "translate(890.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-3",
    transform: "translate(20.000000, 266.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components-/-Field-Input-/-Text-Copy",
    transform: "translate(0.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Arrow-/-Action-/-Bottom",
    transform: "translate(316.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_load_cloud_up_outline",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    mask: "url(#mask-3)",
    fill: "#CACFD3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83C\\uDFA8-Color",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloudIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloud-icon.03389c89.svg";
export { ForwardRef as ReactComponent };